import * as React from 'react';
import { UIHeading2, UIText1, Button, Responsive } from '@cian/ui-kit';

import * as style from './Success.css';
import svg from './assets/success.svg';

export interface INewReviewModalSuccessProps {
  close(): void;
}

export const Success: React.FC<INewReviewModalSuccessProps> = props => {
  const { close } = props;

  return (
    <div data-testid="Success" data-name="Success" className={style['container']}>
      <div className={style['content']}>
        <img className={style['image']} src={svg} alt="Вы успешно отправили отзыв" />
        <div className={style['header']}>
          <UIHeading2>Спасибо за отзыв!</UIHeading2>
        </div>
        <div className={style['text']}>
          <UIText1>Он появится на странице объявления после&nbsp;проверки</UIText1>
        </div>
        <div className={style['action']}>
          <Responsive desktop tablet>
            <Button size="M" onClick={close}>
              Хорошо, спасибо
            </Button>
          </Responsive>
          <Responsive phone>
            <Button size="L" onClick={close}>
              Хорошо, спасибо
            </Button>
          </Responsive>
        </div>
      </div>
    </div>
  );
};
